import type {
  PlayerEvent,
  PlayerEventCallback,
  SubtitleCueEvent,
} from 'bitmovin-player';
import {useEffect} from 'react';
import {usePlayerContext} from './usePlayerContext';

interface UsePlayerCueConfig {
  onCueEnter: (e: SubtitleCueEvent) => void;
  onCueExit: (e: SubtitleCueEvent) => void;
}

export const usePlayerCue = ({
  onCueEnter,
  onCueExit,
}: UsePlayerCueConfig): void => {
  const {player} = usePlayerContext();

  useEffect(() => {
    if (!player) return;

    player.on(
      'cueenter' as PlayerEvent.CueEnter,
      onCueEnter as PlayerEventCallback
    );
    player.on(
      'cueexit' as PlayerEvent.CueExit,
      onCueExit as PlayerEventCallback
    );

    return () => {
      player.off(
        'cueenter' as PlayerEvent.CueEnter,
        onCueEnter as PlayerEventCallback
      );
      player.off(
        'cueexit' as PlayerEvent.CueExit,
        onCueExit as PlayerEventCallback
      );
    };
  }, [player, onCueEnter, onCueExit]);
};
